import React from "react";
import { Form, Col } from "react-bootstrap";
import { RangeSlider } from "rsuite";

export default function MinutesPicker({ formData, setFormData, name }) {
    return (
        <Form.Group as={Col} controlId={`${name}-minutes`} className="col-12 col-xl-2">
            <Form.Label>Minutes</Form.Label>
            <RangeSlider
                max={60}
                value={formData.minuteRange}
                onChange={value => setFormData({ ...formData, minuteRange: value })}
                renderMark={mark => ([0, 60].includes(mark) ? <span>{mark}</span> : null)}
                graduated
            />
        </Form.Group>
    );
}
